import { router, usePage } from '@inertiajs/react';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import SidePanel from './SidePanel';

const EmployeeTimelinePanel = ({ onClose }) => {
    const { base_employee: baseEmployee, timeline } = usePage().props;

    useEffect(() => {
        router.reload({ only: ['timeline'] });
    }, []);

    return (
        <SidePanel
            title='Tijdlijn'
            subtitle={baseEmployee?.name}
            onClose={onClose}
        >
            {!timeline && (
                <p className='text-sm text-gray-500'>Tijdlijn laden...</p>
            )}

            {timeline?.length === 0 && (
                <p className='text-sm text-gray-500'>
                    Er is nog geen tijdlijn voor deze werknemer.
                </p>
            )}

            {timeline?.length > 0 && (
                <ol className='relative border-l border-gray-200'>
                    {timeline.map(entry => (
                        <li key={entry.id} className='mb-6 ml-4 last:mb-0'>
                            <span
                                aria-hidden='true'
                                className='bg-primary-500 absolute -left-1.5 mt-1.5 size-3 rounded-full border border-white'
                            />
                            <time
                                dateTime={entry.created_at}
                                title={dayjs(entry.created_at).format(
                                    'DD-MM-YYYY HH:mm'
                                )}
                                className='text-xs text-gray-500'
                            >
                                {dayjs(entry.created_at).format(
                                    'D MMMM YYYY, HH:mm'
                                )}
                            </time>
                            <p className='text-sm font-semibold text-gray-900'>
                                {entry.action}
                            </p>
                            {entry.content && (
                                <p className='text-sm text-gray-600'>
                                    {entry.content}
                                </p>
                            )}
                            <p className='text-xs text-gray-500'>
                                {entry.user ?? 'Systeem'}
                            </p>
                        </li>
                    ))}
                </ol>
            )}
        </SidePanel>
    );
};

export default EmployeeTimelinePanel;
